import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { UiCloseLinedSmall } from '@cof/omni-gravity-icons-react';
import Typography from '../../overrides/Typography';
import { SEARCH_FILTER_CLEAR_KEYWORD } from '../../../assets/copy';
import { trackClickWithDescription } from '../../../utils/useOneTag';

const useStyles = makeStyles((theme) => ({
  pill: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(0.875, 2),
    borderRadius: theme.spacing(5),
    backgroundColor: theme.palette.spoon.blue[40],
  },
  searchText: {
    marginRight: theme.spacing(0.75),
    color: theme.palette.spoon.white[100],
  },
  clearButton: {
    cursor: 'pointer',
    fill: theme.palette.spoon.white[100],
  },
}));

const SearchKeywordPill = ({ searchText, onClose }) => {
  const classes = useStyles();

  const clearPillHandler = () => {
    trackClickWithDescription(
      'search-revamp-keyword-search-pill-clear',
      'Button',
      ''
    );
    onClose();
  };

  return (
    <Box className={classes.pill}>
      <Typography variant="small4Semibold" className={classes.searchText}>
        {searchText}
      </Typography>
      <UiCloseLinedSmall
        className={classes.clearButton}
        onClick={clearPillHandler}
        aria-label={SEARCH_FILTER_CLEAR_KEYWORD}
        role="button"
        tabIndex="0"
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            clearPillHandler();
          }
        }}
      />
    </Box>
  );
};

export default SearchKeywordPill;
